/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Note_ClearInputs */

const en_us2_exercise_personal_note_clear = /** @type {(inputs: Exercise_Personal_Note_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete note`)
};

const pt_br2_exercise_personal_note_clear = /** @type {(inputs: Exercise_Personal_Note_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apagar nota`)
};

const es_419_exercise_personal_note_clear = /** @type {(inputs: Exercise_Personal_Note_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar nota`)
};

const pt_pt2_exercise_personal_note_clear = /** @type {(inputs: Exercise_Personal_Note_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apagar nota`)
};

const fr_fr2_exercise_personal_note_clear = /** @type {(inputs: Exercise_Personal_Note_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer la note`)
};

const de_de2_exercise_personal_note_clear = /** @type {(inputs: Exercise_Personal_Note_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notiz löschen`)
};

const it_it2_exercise_personal_note_clear = /** @type {(inputs: Exercise_Personal_Note_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina nota`)
};

/**
* | output |
* | --- |
* | "Delete note" |
*
* @param {Exercise_Personal_Note_ClearInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_note_clear = /** @type {((inputs?: Exercise_Personal_Note_ClearInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Note_ClearInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_note_clear(inputs)
	if (locale === "es-419") return es_419_exercise_personal_note_clear(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_note_clear(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_note_clear(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_note_clear(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_note_clear(inputs)
	return en_us2_exercise_personal_note_clear(inputs)
});
export { exercise_personal_note_clear as "exercise-personal.note_clear" }